import React, { Component } from "react";
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';

import Header from "../../header/Header";
import { generalS } from "../../../strings/general";
import { 
  createPost, getPostByPostId, updatePost
 } from "../../general_functions/cpanelFunctions";

 import { 
   getPostsByLanguage
 } from "../../general_functions/general";

import "../../../styles/css/main.css";
import "../../../styles/css/search.css";


class PostMain extends Component {
  constructor(props) {
    super(props);
    this.state = {
      type: "", 
      name: "",
      details: [],
      imageName: '',
      currentLang: 'En',
      data: [], // language: "", value: {}
      counter: 0,
      uploadInput: '',
      posts: [],
      stateUpdate: 0,
      imgState: false,
      postId: 0,
      _id: 0,
    }
  }

  componentDidMount() {
    let { language } = this.props.context;
    let lang = "";
    if (language == 2) {
      lang = 'En';
    } else if (language == 1) {
      lang = 'Ar';
    } else {
      lang = 'Kr'
    }

    getPostsByLanguage(lang, res => {
      let { post } = res;
      let temp = [];
      let tempObj = {}
      if (post) {
        for (let i = 0; i < post.length; i++) {
          tempObj = post[i].data.value;
          tempObj._id = post[i]._id;
          tempObj.postId = post[i].postId;
          tempObj.imageName = post[i].imageName
          temp.push(tempObj)
        }

        this.setState({ posts: temp })
      }
    });
  }

  handleChange = event => {
    this.setState({ type: event.target.value });
  };

  handleLanguage = event => {
    let currentLang = event.target.value;
    this.setState({ currentLang });
   
    let { data } = this.state;
    if (data && data.length > 0)
      for (let i = 0; i < data.length; i++){
        if (currentLang != data[i].language){
          this.setState({
            title: "", subTitle: "",  details: []
          })
        } else {
          this.setState({
            title: data[i].value.title, 
            subTitle: data[i].value.subTitle,
            video: data[i].value.video,
            details: data[i].value.details,
          })
          break;
        }
      }
  };

  inputHandler = name => event => {
    this.setState({ [name]: event.target.value });
  };

  saveHandler = () => {
    let { data, uploadInput, stateUpdate, postId, _id, imageName } = this.state;
    let counter = 0;
    
    Object.values(data).map((d, i) => {
      if (d.value.title) { counter = counter + 1; }
    });

    let co = true;
    if (counter < 3) {
      co = window.confirm("You didnt add data for all languages, are you sure you want to save it!");
    }

    let dataObj = { data, imageName };

    if (co) {
      if (uploadInput != '') {
        const dataForm = new FormData();
        dataForm.append('file', uploadInput);
        dataForm.append('filename', `${uploadInput.lastModified}_${uploadInput.name}`);
        fetch('http://localhost:3001/post/uploadimage', {
          method: 'POST',
          body: dataForm,
        }).then((response) => {
          if (response.status == 200) {
            if (stateUpdate == 0) {
              createPost(dataObj, res => {
                if (res.success) {
                  this.props.handleSnackbar(
                    "post has been saved succesfuly!"
                  );
                  this.resetForm();
                } else {
                  this.props.handleSnackbar(
                    "Something went wrong!"
                  );
                }
              });
            } else {
              dataObj.postId = postId;
              dataObj._id = _id;
             this.uploadHadler(dataObj)
            }
          }
        });
      } else {
        dataObj.postId = postId;
        dataObj._id = _id;
        this.uploadHadler(dataObj)
      }
    }
  }

  uploadHadler = (dataObj) => {
    updatePost(dataObj, res => {
      if (res.success) {
        this.props.handleSnackbar(
          "post has been updated succesfuly!"
        );
        this.resetForm()
      } else {
        this.props.handleSnackbar(
          "Something went wrong!"
        );
      }
    });
  }

  addDataHandler = () => {
    let { currentLang, title, subTitle, type, 
      video, details, data, 
      counter, uploadInput, stateUpdate } = this.state;

    if (type == "" || typeof title == "undefined" 
    || typeof subTitle == "undefined" || details.length == 0 ) {
      alert("please file out the requred fields!");
      return;
    }

    if (stateUpdate == 0 && uploadInput == '') {
      alert("please, choose an image!");
      return;
    }

    let currentData = {
      title, subTitle, type, video, details
    }

    if (data.length == 0) {
      data.push({
        language: currentLang, value: currentData
      })
    } else {
      for (let i = 0; i < data.length; i++) {
        if (data[i].language == currentLang) {
          data[i].value = currentData;
          return;
        }
      }
      data.push({
        language: currentLang, value: currentData
      })
    }
    
    this.setState({
      title: "", data, subTitle: "",  details: [], counter: counter + 1
    })
  }

  resetForm = () => {
    this.setState({
      type: "", 
      title: "",
      subTitle: "",
      video: "",
      details: [],
      imageName: '',
      currentLang: 'En',
      data: [],
      counter: 0,
      uploadInput: '',
      stateUpdate: 0,
    })
  }

  fileInputHandler = (event) => {
    let uploadInput = event.target.files[0];
    let imageName = `${uploadInput.lastModified}_${uploadInput.name}`;
    this.setState({ uploadInput, imageName});
  }

  searchHandler = (event, values) => {
    this.setState({ 
      postId: values.postId, 
      _id: values._id ,
      imageName: values.imageName,
    });

    if (values) {
      getPostByPostId(values.postId, res => {
        if (res.post) {
          let data = res.post.data;
          let v = data[0].value;
          let currentLang = data[0].language;

          this.setState({ 
            type: v.type, data, currentLang, 
            stateUpdate: 1, counter: 1 })
        }
      })
    } else {
      this.setState({ stateUpdate: 0, counter: 0 })
    }
  };

  buttonManager = () => {
    let { counter, stateUpdate } = this.state;
    if (counter >= 1 && stateUpdate == 0) {
      return <Button onClick={this.saveHandler}> Save</Button>
    } else if (counter >= 1 && stateUpdate == 1)  {
      return <Button onClick={this.saveHandler}>Update</Button>
    } else {
      return("");
    }
  }

  render() {
    let { context } = this.props;
    let { language } = context;
    let { type, data, currentLang, details, 
      title, subTitle, video, counter, posts, stateUpdate } = this.state;

    return (
      <div className={"page-controler"}>
        <Header context={context} />
        <div className={"wrapper"}>
          <div style={{marginBottom: 24}}>
            Update post
            <Autocomplete
              id="combo-box-demo"
              options={posts}
              onChange={this.searchHandler}
              getOptionLabel={option => {
                return option.title;
              }}
              style={{ width: "50%", paddingBottom: 24 }}
              renderInput={params => <TextField {...params} label="Combo box" variant="outlined" />}
            />
            <hr style={{width: "50%"}}/>
          </div>
          <br/>
          <br/>
          <div className={"post-main-container"}>
            <div className={"input-container"}>  
              <InputLabel id="demo-simple-select-label">Language</InputLabel>
              <Select
                style={{width: "100%"}}
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={currentLang}
                onChange={this.handleLanguage}
              >
                <MenuItem value={"En"}>En</MenuItem>
                <MenuItem value={"Ar"}>Ar</MenuItem>
                <MenuItem value={"Kr"}>Kr</MenuItem>
              </Select>
            </div>
            <div className={"input-container"}>  
              <InputLabel id="demo-simple-select-label">Type</InputLabel>
              <Select
                style={{width: "100%"}}
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={type}
                onChange={this.handleChange}
              >
                <MenuItem value={"latestProject"}>{generalS.latestProject[language]}</MenuItem>
                <MenuItem value={"upcomingEvents"}>{generalS.upcomingEvents[language]}</MenuItem>
                <MenuItem value={"workshopTraiing"}>{generalS.workshopTraiing[language]}</MenuItem>
                <MenuItem value={"calender"}>{generalS.calender[language]}</MenuItem>

                <MenuItem value={"ourmission"}>{generalS.ourMission[language]}</MenuItem>
                <MenuItem value={"film"}>{generalS.film[language]}</MenuItem>
                <MenuItem value={"desing"}>{generalS.design[language]}</MenuItem>
                <MenuItem value={"print"}>{generalS.print[language]}</MenuItem>
                <MenuItem value={"onlintv"}>{generalS.onlineTV[language]}</MenuItem>

                <MenuItem value={"history"}>{generalS.history[language]}</MenuItem>
              </Select>
            </div>
            <div className={"input-container"}>
              <label>Title</label>
              <TextField  value={title}
              required className={"search-input"} type="text" onChange={this.inputHandler("title")}/>
            </div>
            <div className={"input-container"}>
              <label>sub-title</label>
              <TextField value={subTitle}
              required className={"search-input"} type="text" onChange={this.inputHandler("subTitle")}/>
            </div>
            <div className={"input-container"}>
              <label>Image</label>
              <input type="file" name="file" onChange={this.fileInputHandler}/>
            </div>
            <div className={"input-container"}>
              <label>Video Url</label>
              <input required value={video}
              className={"search-input"} type="text" onChange={this.inputHandler("video")}/>
            </div>
            <div style={{width: '100%', display: 'flex',}}>
              {data && data.length > 0 ?
                data.map((d, i) => {
                  return(<p style={{ marginLeft: 48, marginRight: 48 }}>{d.language}</p>)
                }): ("")
              }
            </div>
            
            <Button onClick={this.addDataHandler}>
              Next
            </Button>
            
            {this.buttonManager()}
          </div>
        </div>
      </div>
    );
  }
}

export default PostMain;
